import React from 'react'
import SEO from '../components/common/SEO'
import AboutBanner from '../components/about/AboutBanner'
import CompanyIntro from '../components/about/CompanyIntro'
import OurStory from '../components/about/OurStory'
import MissionVision from '../components/about/MissionVision'
import CoreValues from '../components/about/CoreValues'
import TeamSection from '../components/about/TeamSection'
import AboutCounter from '../components/about/AboutCounter'
import CTASection from '../components/common/CTASection'

const About = () => {
  return (
    <>
      <SEO
        title="About AZ Construction | Trusted Construction Company in Indore"
        description="Learn about AZ Construction, a trusted construction and property development company in Indore committed to quality construction, transparency, timely delivery, and customer satisfaction."
        url="https://azconstruction.com/about-us"
      />
      <AboutBanner />
    <CompanyIntro />
    <OurStory />
    <MissionVision />
    <CoreValues />
    <TeamSection />
    <AboutCounter />
    <CTASection />
    </>

  )
}

export default About